export default "__VITE_ASSET__9d82f882__"